import * as React           from "react";
import {createElement as h} from "react";

import {Types} from "../types";

export const UseState = <Model,>({next, _key=undefined, getInitValue=undefined, initValue=undefined, defaultValue=undefined}:{
    next          : (state:Types.Common.React.UseState.UseStateNext<Model>) => JSX.Element,
    _key         ?: React.Key,
    getInitValue ?: () => Model,
    initValue    ?: Model,
    defaultValue ?: Model,
}): JSX.Element => h(UseState1, {next, _key, getInitValue, initValue, defaultValue});

interface P<T> {
    _key,
    getInitValue?: () => T;
    initValue?: T;
    defaultValue?: T;
    next: (_: Types.Common.React.UseState.UseStateNext<T>) => any;
}

interface S<T> {
    value: T;
    key,
}

export class UseState1<T> extends React.Component<P<T>,S<T>> {
    unmounted = null;

    constructor(props, context) {
        super(props, context);

        this.state = {
            value: props.getInitValue ? props.getInitValue() : props.initValue,
            key: props._key,
        };
    }
    componentWillUnmount() {
        this.unmounted = Date.now();
    }
    componentDidUpdate(prevProps: Readonly<P<T>>, prevState: Readonly<S<T>>) {
        if (prevProps._key !== this.props._key && !this.unmounted) {
            this.setState({
                key: this.props._key,
                value: this.props.getInitValue ? this.props.getInitValue() : this.props.initValue,
            });
        }
    }

    setState(state, callback?) {
        if (!this.unmounted || Date.now() - this.unmounted > 3000) {
            super.setState(state, callback);
            return;
        }
    }

    render() {
        const {next, defaultValue, _key, getInitValue, initValue} = this.props;
        const {value, key} = this.state;
        return next({
            value: key === _key ? (
                value ?? defaultValue
            ) : (
                getInitValue ? getInitValue() : initValue ?? defaultValue
            ),
            onChange: (value1, cb = undefined) => (!this.unmounted || Date.now() - this.unmounted > 3000) && this.setState({value: value1}, cb),
            change: (reduceValue, cb) => {
                this.setState(
                    (state) => ({
                        ...state,
                        value: reduceValue(state.value ?? defaultValue),
                    }),
                    cb
                );
            },
        }) ?? null;
    }
}
